<template>
  <div
    class="chat_list__item d-grid grid-col-max-1 gap-4 unselectable py-2 px-2 px-md-5"
    :class="{
      'chat_list__item--active secondary lighten-2': $route.params.id === chatItem.id,
      'chat_list__item--personal': chatItem.type === 'PERSONAL',
      'chat_list__item--group': chatItem.type === 'GROUP',
    }"
    @click="
      $route.params.id !== chatItem.id &&
        $router.replace({ name: 'chatById', params: { id: chatItem.id } })
    "
    @contextmenu="handleContextMenu"
  >
    <ChatAvatar
      :src="chatItem.displayData.photo"
      :text="chatItem.displayData.name"
      :online="
        chatItem.type === 'PERSONAL' &&
        chatItem.interlocutorUser &&
        chatItem.interlocutorUser.user.wasOnlineAt === 'online'
      "
      :isDelete="chatItem.type === 'PERSONAL' && chatItem.interlocutorUser.user.isUserDelete"
      class="align-self-center"
    />
    <div class="chat_list__item__info align-self-center">
      <div
        class="chat_list__item__info__head d-grid grid-col-1-max gap-1 secondary--text text--darken-2"
      >
        <div class="chat_list__item__info__title f14 fw400">
          {{ chatItem.displayData.name }}
        </div>
        <div class="chat_list__item__info__date d-flex gap-1 f12 fw400">
          <div
            class="chat_list__item__info__seen d-flex justify-center"
            v-if="chatItem.messages.length && userData.id === lastMessage.senderId"
            :class="{ 'chat_list__item__info__seen--true': lastMessage.isSeen }"
          >
            {{ '✓' }}
          </div>
          {{
            $formatDate(
              chatItem.messages.length
                ? lastMessage.updatedAt || lastMessage.sentAt
                : chatItem.createdAt,
            )
          }}
        </div>
      </div>
      <div class="chat_list__item__info__body d-grid grid-col-1-max gap-4">
        <div class="chat_list__item__info__body__left">
          <div
            class="chat_list__item__info__type f12 fw400 primary--text text--lighten-2 mt-1"
            v-if="chatItem.displayData.info"
          >
            {{ chatItem.displayData.info }}
          </div>
          <div
            v-if="inChatTyping"
            class="chat_list__item__info__who f14 fw400 secondary--text text--darken-2 mt-2"
          >
            {{ inChatTyping }}
          </div>
          <template v-else>
            <div
              v-if="chatItem.type === 'GROUP' && chatItem.messages && chatItem.messages.length"
              class="chat_list__item__info__who f12 fw400 secondary--text text--darken-2 mt-1"
            >
              {{
                lastMessage.senderId === userData.id
                  ? 'You'
                  : lastMessage.senderData.first_name + ' ' + lastMessage.senderData.last_name
              }}
            </div>
            <div
              v-if="chatItem.messages && chatItem.messages.length"
              class="chat_list__item__info__content f14 fw400 secondary--text text--darken-2 mt-2"
            >
              <BaseIcon
                v-if="
                  lastMessage.originalMessageId
                    ? Array.isArray(lastMessage.originalMessage.attachments)
                      ? lastMessage.originalMessage.attachments.length
                      : lastMessage.originalMessage.attachments !== null
                    : Array.isArray(lastMessage.attachments)
                    ? lastMessage.attachments.length
                    : lastMessage.attachments !== null
                "
                icon="chat-file"
                color="#52525F"
              />
              {{
                lastMessage.originalMessage
                  ? lastMessage.originalMessage.content
                  : lastMessage.content
              }}
            </div>
          </template>
        </div>
        <ChatCounter
          :counter="messagesUnSeenCounter"
          :isNotificationsEnabled="
            chatItem.currentUser && chatItem.currentUser.isNotificationsEnabled
          "
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import ChatAvatar from 'components/chat/ChatAvatar'
import ChatCounter from 'components/chat/ChatCounter'
export default {
  name: 'ChatListItem',
  components: { ChatAvatar, ChatCounter },
  props: {
    chatItem: Object,
    index: Number,
    chatTranslations: Object,
  },
  computed: {
    ...mapGetters('user', ['userData']),
    messagesUnSeenCounter() {
      return Number(this?.chatItem?._count?.messages)
    },
    messagesUnseen() {
      return this.chatItem.messages.filter((i) => i.senderId !== this.userData.id && !i.isSeen)
    },
    lastMessage() {
      let message = this.chatItem.lastMessage
      let sender = this.chatItem.participants.find((i) => i.user.id === message.senderId)
      message.senderData = sender ? sender.user : {}
      return message
    },
    inChatTyping() {
      const textOne = this.chatTranslations.typing_user.firstLetterToLowerCase() + '...'
      const textTwo = this.chatTranslations.typing_users.firstLetterToLowerCase() + '...'
      const textTree = this.chatTranslations.and_more
      const usersIsTypingArray =
        this.chatItem.usersIsTyping && Object.values(this.chatItem.usersIsTyping)
      const usersIsTypingGroupText = () => {
        if (usersIsTypingArray?.length > 0) {
          const getUserFullName = (user) => user.first_name + ' ' + user.last_name
          const userOne = usersIsTypingArray[0]
          const userOneFullName = getUserFullName(userOne)
          if (usersIsTypingArray.length === 1) {
            return userOneFullName + ' ' + textOne
          } else if (usersIsTypingArray.length > 1) {
            const userTwo = usersIsTypingArray[1]
            const userTwoFullName = getUserFullName(userTwo)
            return (
              userOneFullName +
              ', ' +
              userTwoFullName +
              (usersIsTypingArray.length > 2 ? ', ' + textTree + ' ' + (usersIsTypingArray.length - 2) : '') +
              ' ' +
              textTwo
            )
          }
        }
      }
      return usersIsTypingArray?.length
        ? this.chatItem.type === 'PERSONAL'
          ? textOne
          : usersIsTypingGroupText()
        : null
    },
  },
  methods: {
    handleContextMenu(value) {
      // console.log('handleContextMenu', value)
      this.$emit('contextmenu', value)
    },
  },
}
</script>

<style lang="scss" scoped>
.chat_list__item {
  height: 90px;
  position: relative;
  transition: 0.3s;
  @media screen and (max-width: 400px) {
    gap: 8px !important;
  }
  @media screen and (max-width: 350px) {
    min-height: 90px;
    height: auto;
    max-height: 120px;
  }
  &__info {
    height: 100%;
    &__title {
      color: inherit;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    &__content {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    &__seen {
      position: relative;
      width: 10px;
      &--true {
        &:before {
          content: '✓';
          position: absolute;
          left: 5px;
        }
      }
    }
  }
  &::before {
    position: absolute;
    width: 6px;
    height: 100%;
    background: var(--v-primary-base);
    opacity: 0;
    transition: 0.3s;
    content: '';
  }
  &:hover {
    cursor: pointer;
    &::before {
      opacity: 1;
    }
  }
  &--active {
    &::before {
      opacity: 1;
    }
  }
  &--group {
    .chat_list__item__info__content {
      -webkit-line-clamp: 1;
    }
  }
}
</style>
